import NodeOutputDetails from './NodeOutputDetails';
import React from 'react';
import { Dialog, Paper } from '@mui/material';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { WorkflowNode } from 'api/model';
import { ExecutionNodeStatusEnum } from 'types';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type NodeOutputDialogProps = {
  node: WorkflowNode;
  open: boolean;
  onClose: () => void;
  workflowExecutionId: string;
  nodeStatus?: ExecutionNodeStatusEnum;
  onValueSelect?: (value: string) => void;
};

const NodeOutputDialog = ({
  node,
  open,
  onClose,
  workflowExecutionId,
  nodeStatus,
  onValueSelect,
}: NodeOutputDialogProps) => {
  return (
    <Dialog
      fullScreen={true}
      maxWidth="xl"
      open={open}
      PaperComponent={Paper}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      TransitionComponent={Transition}
      className="p-10 "
      PaperProps={{
        sx: (theme) => ({
          borderRadius: '16px',
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden',
        }),
      }}
    >
      <div className=" h-full w-full">
        <NodeOutputDetails
          onValueSelect={onValueSelect}
          node={node}
          onClose={onClose}
          workflowExecutionId={workflowExecutionId}
          nodeStatus={nodeStatus}
        />
      </div>
    </Dialog>
  );
};

export default NodeOutputDialog;
